import { ModalForm, ProFormSelect, ProFormText } from '@ant-design/pro-components';
import PropTypes from 'prop-types';
import { createCollection, updateCollection } from '../services/collect';

const AgentFeishuContactCollectionForm = ({
  collectionType,
  connections,
  onSaved,
  organizationId,
  record,
  trigger,
}) => {
  const editing = Boolean(record);
  return (
    <ModalForm
      title={editing ? '修改采集配置' : '创建采集配置'}
      trigger={trigger}
      width={520}
      initialValues={record}
      modalProps={{ destroyOnHidden: true }}
      onFinish={async (values) => {
        await (editing ? updateCollection : createCollection)({
          data: { ...values, collectionType, id: record?.id, organizationId },
        });
        onSaved();
        return true;
      }}
    >
      <ProFormText name="name" label="采集配置名称" rules={[{ required: true }]} />
      <ProFormSelect
        name="connectionId"
        label="飞书通讯录连接"
        options={connections.map(({ id, name }) => ({ label: name, value: id }))}
        rules={[{ required: true }]}
      />
    </ModalForm>
  );
};

AgentFeishuContactCollectionForm.propTypes = {
  collectionType: PropTypes.string.isRequired,
  connections: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
  ).isRequired,
  onSaved: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
  record: PropTypes.shape({
    connectionId: PropTypes.string.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  trigger: PropTypes.node.isRequired,
};

export default AgentFeishuContactCollectionForm;
